import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function postAcceptPersonalDataAndTos() {
    const { apiPostAcceptPersonalDataAndTos } = apiConfig.getStaticUrls();

    return postFetch(apiPostAcceptPersonalDataAndTos);
}
